import SbUtils from '../../../Utils/SbUtils'

const PostMedia = ( { post, postIndex, feedSettings } ) => {

}

export default PostMedia;